export default __webpack_public_path__ + "static/media/Clamps.44332c24.png";